import React from "react";
import { Link } from "react-router-dom";

// Exact CTIA/Twilio-compliant opt-in copy — do not paraphrase. Must stay a
// standalone, optional, unchecked-by-default checkbox (never bundled with TOS).
export const SMS_OPTIN_TEXT =
  "I agree to receive SMS messages from Boat RV Moving. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for assistance.";

export function SmsOptInCheckbox({ checked, onChange, testid = "sms-optin-checkbox" }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none" data-testid={`${testid}-label`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testid}
        className="w-4 h-4 mt-0.5 accent-[#FF3B30] shrink-0"
      />
      <span className="text-xs text-zinc-400 leading-relaxed">
        {SMS_OPTIN_TEXT} View our{" "}
        <Link to="/privacy-policy" target="_blank" data-testid={`${testid}-privacy-link`} className="text-[#FF3B30] hover:text-white underline underline-offset-2">
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link to="/terms" target="_blank" data-testid={`${testid}-terms-link`} className="text-[#FF3B30] hover:text-white underline underline-offset-2">
          Terms
        </Link>
        .
      </span>
    </label>
  );
}

export function TosCheckbox({ checked, onChange, testid = "tos-checkbox" }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none" data-testid={`${testid}-label`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testid}
        className="w-4 h-4 mt-0.5 accent-[#FF3B30] shrink-0"
      />
      <span className="text-xs text-zinc-400 leading-relaxed">
        I agree to the{" "}
        <Link to="/terms" target="_blank" data-testid={`${testid}-terms-link`} className="text-[#FF3B30] hover:text-white underline underline-offset-2">
          Terms and Conditions
        </Link>{" "}
        and{" "}
        <Link to="/privacy-policy" target="_blank" data-testid={`${testid}-privacy-link`} className="text-[#FF3B30] hover:text-white underline underline-offset-2">
          Privacy Policy
        </Link>
      </span>
    </label>
  );
}

// Shared page shell for the legal documents
export function LegalPage({ title, updated, children, testid }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white px-4 py-12" data-testid={testid}>
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="block font-display text-2xl font-black uppercase tracking-tight mb-10">
          Boat<span className="text-[#FF3B30]">RV</span>Moving
        </Link>
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#FF3B30] font-bold">Legal</span>
        <h1 className="font-display text-4xl md:text-5xl font-black uppercase mt-2 mb-1 leading-none">{title}</h1>
        <p className="text-xs text-zinc-600 mb-10">Last updated: {updated}</p>
        <div className="space-y-8 text-sm text-zinc-400 leading-relaxed">{children}</div>
        <p className="text-xs text-zinc-600 mt-12">
          Questions? <a href="mailto:info@boatrvmoving.com" className="text-[#FF3B30] hover:text-white underline underline-offset-2">info@boatrvmoving.com</a>
          {" · "}
          <Link to="/" className="hover:text-white underline underline-offset-2">Back to home</Link>
        </p>
      </div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-lg font-black uppercase text-white mb-2">{title}</h2>
      {children}
    </section>
  );
}
